import type { ReactNode } from "react";
import styles from "./StatusBadge.module.css";

export type StatusBadgeTone = "neutral" | "info" | "primary" | "success" | "warning" | "error" | "muted";

/** Status / Message из Figma: плашка статуса или отметки на карточке. */
export function StatusBadge({ tone, icon, children }: { tone: StatusBadgeTone; icon?: ReactNode; children: ReactNode }) {
  return (
    <span className={`${styles.badge} ${styles[tone]}`}>
      {icon}
      {children}
    </span>
  );
}
